<template>
<body id="page-top" class="member-page-body">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio member-page-section" id="portfolio">
    
            <div class="container">
                
                <div class="row align-items-start">
                  <div class="loa-lab-flex">
                    <div class="col loa-lab-steps steps-done">
                      1
                    </div>
                    <div class="col loa-lab-steps steps-done">
                      2
                    </div>
                    <div class="col loa-lab-steps steps-done">
                      3
                    </div>
                    <div class="col loa-lab-steps steps-active">
                      4
                    </div>
                  </div>
                <div class="row justify-content-center loa-form">
                    <div class="login-form">
                      <div>
                        <p>Our Customer Experience Advocate may need to call you for verification on the request for the 
                          laboratory test or will send an SMS to notify you of the created Letter of Authorization(LOA)<br><br>Please make sure to type in your correct and active mobile number.</p>
                      </div>
                            
                <div class="row justify-content-center d-flex align-items-center">
                    <div class="col-5" >
                        <strong class="phone-label">Type your mobile number</strong>
                      </div>
                    <div class="col-7">
                        <div class="input-phone-number col-md-12">
                              <label><strong class="phone-number">+63</strong></label>
                            <vue-phone-number-input v-model="vuePhone.phone" v-bind="vuePhone.props"></vue-phone-number-input>
                      </div>
                    </div>
                </div>
                <div class="row justify-content-center d-flex align-items-center">
                    <div class="col-5">
                        <strong class="phone-label">Re-type your mobile number</strong>
                      </div>
                    <div class="col-7">
                        <div class="input-phone-number col-md-12">
                              <label><strong class="phone-number">+63</strong></label>
                            <vue-phone-number-input v-model="vuePhone.phone" v-bind="vuePhone.props"></vue-phone-number-input>
                      </div>
                    </div>
                </div>
                      
                      
                         
                      
                    
                    </div>
                       <div class="col-md-12 member-custom-btn">
                  <a style="float:left" type="button" class="btn btn-primary btn-lg"><router-link to="/member-page">CANCEL</router-link></a>
                  <a type="button" class="btn btn-primary btn-lg"><router-link to="/loa-lab-3">PREVIOUS</router-link></a>
                  <button class="btn btn-primary btn-lg"><router-link to="/loa-lab-5">NEXT</router-link></button>
            </div>
                </div>
        </div>
            </div>
        </section>
</body>
</template>



  

<script>
export default {
  name: "",
  data() {
    return {
      vueTel: {
        phone: "",
        props: {
          preferredCountries: ["PH"],
          placeholder: "Enter your phone",
          mode: "international",
          inputOptions: {
            showDialCode: true
          },
          disabledFormatting: false,
          wrapperClasses: "country-phone-input"
        }
      },
      vuePhone: {
        phone: "",
        props: {
          clearable: true,
          fetchCountry: true,
          preferredCountries: ["PH"],
          noExample: false,
          translations: {
            countrySelectorLabel: "Country code",
            countrySelectorError: "Error",
            phoneNumberLabel: "Enter your phone",
            example: "Example:"
          }
        }
      }
    };
  }
};
</script>

<style>
.country-phone-input .dropdown:focus {
  outline: none;
  color: grey;
}
</style>

